import { useTranslation } from 'react-i18next';
import { isKnownGovernorate, useGovernorateOptions } from '@/lib/governorates';

/** Dropdown of the 24 Tunisian governorates for address forms.
 *  The stored value is the FRENCH name (stable string, printed as-is on
 *  documents / PDFs); the visible labels follow the UI language (Arabic
 *  names in AR). A legacy free-text city that isn't one of the 24 stays
 *  selectable so pre-filled clients don't silently lose their city. */
export function CitySelect({
  label,
  value,
  onChange,
  required,
  selectClassName,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  /** Extra classes for the <select> control (e.g. rounded-xl in modals). */
  selectClassName?: string;
}) {
  const { t } = useTranslation();
  const options = useGovernorateOptions();
  const isKnown = isKnownGovernorate(value);
  return (
    <div>
      <label
        className="text-[14px] font-medium mb-1.5 block"
        style={{ color: 'var(--pro-text-muted)' }}
      >
        {label}{' '}
        {required && <span style={{ color: 'var(--pro-danger)' }}>*</span>}
      </label>
      <select
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full h-11 px-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-orange-300 ${selectClassName ?? 'rounded-lg'}`}
        style={{
          border: '1px solid var(--pro-border)',
          background: 'white',
          color: value ? 'var(--pro-text-dark)' : 'var(--pro-text-light)',
        }}
      >
        <option value="">
          {t('pro.checkout.city_select', 'Sélectionner un gouvernorat')}
        </option>
        {value && !isKnown && <option value={value}>{value}</option>}
        {options.map((g) => (
          <option key={g.value} value={g.value}>
            {g.label}
          </option>
        ))}
      </select>
    </div>
  );
}
